import React, { useState } from "react";
import { Button } from "reactstrap";
import { Edit, Trash2, Search } from "react-feather";
import { useNavigate } from "react-router-dom";
import AddUnavailableDates from "./AddUnavailableDates";

const ProductListTable = ({
  products,
  handleEditClick,
  handleDeleteClick,
  refreshProductsList
}) => {
  const [activeDateForm, setActiveDateForm] = useState(null);
  const initialUnavailableDates = [
    { id: 6, from_date: "2025-06-04", to_date: "2025-06-07" },
    { id: 3, from_date: "2025-06-10", to_date: "2025-06-12" },
  ];

  const handleSaveDates = (productId, newRanges) => {
    console.log("Saved unavailable dates for product", productId, newRanges);
    // Add API or state logic here to update the product
    setActiveDateForm(null);
  };
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Image</th>
          <th>Titre</th>
          <th>Statut</th>
          <th>Prix</th>
          <th>Dates indisponibles</th>
          <th>Évaluations</th>
          <th>Actions</th>

        </tr>
      </thead>
      <tbody>
        {products.map((product, index) => (
          <tr key={index}>
            <td className="align-middle">
              <img
                src={product.product_images[0]?.image || "default-image-url"}
                alt=""
                style={{ width: "60px", height: "auto" }}
              />
            </td>
            <td className="align-middle">{product.title}</td>
            <td className="align-middle">
              <span style={{ background: `${product.approval_status == 'pending' ? '#deb800' : '#1fb300'}`, color: 'white', padding: '5px 10px', borderRadius: '6px', textTransform: 'capitalize', fontSize: '12px' }}>
                {product.approval_status}
              </span>
            </td>
            <td className="align-middle">€ {product.price}</td>
            <td className="align-middle">
              <AddUnavailableDates
                product={product}
                onSave={() => refreshProductsList()}
              />

            </td>
            <td className="align-middle">
              {[...Array(5)].map((_, i) => (
                <i
                  key={i}
                  className={`fa ${i < product.average_rating ? "fa-star" : "fa-star-o"
                    }`}
                  style={{
                    color: i < product.average_rating ? "#ffc107" : "#e4e5e9",
                  }}
                ></i>
              ))}
            </td>
            <td className="align-middle">
              <Button
                style={{ margin: "5px" }}
                color="primary"
                type="button"
                className="mr-2"
                onClick={() => handleEditClick(product.id)}
              >
                <Edit />
              </Button>
              <Button
                style={{ margin: "5px" }}
                color="warning"
                type="button"
                className="mr-2"
                onClick={() => handleDeleteClick(product.id)}
              >
                <Trash2 />
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ProductListTable;
